import { wrap, ContainerComponent } from 'AppReact';
import Schema from 'AppReact/schema';
import { InputError, Input } from 'molecules';
import Controller from './controller';
import { SubSectionLabel, Seprator } from '../../../../common/atoms';
import { SubsectionHeader } from '../../../../common/molecules';
import { occupantsSchema, defaultOccupant } from '../../../../types';
import { FieldWrapper, DisabledWrapper } from '../../../../common/wrappers';
import { Dropdown } from 'containers';
import { FlexBoxWrapper, GenericWrapper } from 'wrappers';
import { LabeledDatepicker } from 'containers';
import {  SecondaryTextXs } from 'atoms';
import { isLastItem } from '../../../../utils';

const WrappedDropdown = wrap(Dropdown, FieldWrapper);
const WrappedInput = wrap(Input, FieldWrapper);
const WrappedDatePicker = wrap(LabeledDatepicker, FieldWrapper);
const WrappedInputError = wrap(InputError, FieldWrapper);
const WrappedDisabledEmail = wrap(Input, DisabledWrapper);


const options = [
    {
        id: 'leaseholder',
        display: 'Lease Holder',
    },
    {
        id: 'occupant',
        display: 'Occupant',
    },
]

export const definition = ({
    controller: Controller,
    name: "Occupant",
    initialProps: ({ occupantIndex, language, occupant, occupants, onReview }) => ({ occupantIndex, language, occupant, occupants, onReview }),
    props: {
        occupant: Schema(occupantsSchema, 'object', { defaultValue: defaultOccupant }),
        occupants: Schema(occupantsSchema, 'array'),
        onReview: Schema('boolean', 'primitive'),
        language: Schema( {}, 'object'),
        occupantIndex: Schema('integer', 'primitive'),
    },
    elements: [
        {
            wrapper: GenericWrapper,
            name: 'Wrapper',
            elements: [
                {
                    component: SubSectionLabel,
                    name: 'SubSectionLabel',
                    renderIf: ({ occupant, onReview }) => (occupant && occupant.id == 'leaseholder') && !onReview,
                    displayValue: ({ occupant }) => occupant?.name || "Occupant name",
                },
                {
                    component: SubsectionHeader,
                    name: 'DeleteButton',
                    renderIf: ({ occupant, onReview, occupantIndex }) => {
                        return (occupant && occupant.id !== 'leaseholder') && !onReview && occupantIndex !== 0
                    },
                    bindings: ({ occupant, occupants }) => ({ label: occupant?.name || "Occupant name", resourceList: occupants, id: occupant.id })
                },
                {
                    wrapper: FlexBoxWrapper,
                    name: 'Status',
                    renderIf: ({ occupant }) => occupant && occupant.id == 'leaseholder',
                    elements: [
                        {
                            component: SubSectionLabel,
                            name: 'Label',
                            displayValue: ({ language }) => `${language?.status || 'Status'}:`,
                            displayState: () => ({ bold: true }),
                        },
                        {
                            component: SubSectionLabel,
                            name: 'Description',
                            displayValue: () => ' Lease Holder',
                        },
                    ]
                },
                {
                    component: WrappedDropdown,
                    name: 'StatusDropdown',
                    renderIf: ({ occupant }) => occupant && occupant.id !== 'leaseholder',
                    bindings: ({ occupant, occupants }) => {
                        return ({ occupants, occupant, label: 'Status: ', selectedOptionId: occupant.status, options })
                    }
                },
                {
                    component: WrappedInput,
                    name: 'Name',
                    bindings: ({ language, occupant, occupants }) => ({ occupants, occupant, label: `${language?.full_name || 'Full Name'}:` , value: occupant.name })
                },
                {
                    component: WrappedInputError,
                    name: 'NameError',
                    bindings: ({ occupant }) => ({ error: occupant.nameError }),
                    renderIf: ({ occupant, onReview }) => !!occupant.nameError && !onReview,
                },
                {
                    component: WrappedDatePicker,
                    name: 'DOB',
                    bindings: ({ language, occupant, occupants }) => ({ occupants, occupant, selectedDate: occupant.dob, label: { values: [`${ language?.dob || 'Date of birth'}:`], keys: ['text'], component: SecondaryTextXs }, })
                },
                {
                    component: WrappedInputError,
                    name: 'DOBError',
                    bindings: ({ occupant }) => ({ error: occupant.dobError }),
                    renderIf: ({ occupant, onReview }) => !!occupant.dobError && !onReview,
                },
                {
                    component: WrappedDisabledEmail,
                    name: 'Email',
                    bindings: ({ occupants, occupant }) => ({  occupants, occupant,label: 'Email:', value: occupant.email }),
                    renderIf: ({ occupant }) => occupant && occupant.id == 'leaseholder',
                },
                {
                    component: WrappedInput,
                    name: 'Email',
                    bindings: ({ occupants, occupant }) => ({  occupants, occupant,label: 'Email:', value: occupant.email }),
                    renderIf: ({ occupant }) => occupant && occupant.id !== 'leaseholder',
                },
                {
                    component: WrappedInputError,
                    name: 'EmailError',
                    bindings: ({ occupant }) => ({ error: occupant.emailError }),
                    renderIf: ({ occupant, onReview }) => !!occupant.emailError && !onReview,
                },
                {
                    component: WrappedInput,
                    name: 'SSN',
                    bindings: ({ language, occupant, occupants }) => ({ occupants, occupant, label: `${ language?.ssn || 'Social Security Number'}:`, value: occupant.ssn })
                },
                {
                    component: WrappedInputError,
                    name: 'SSNError',
                    bindings: ({ occupant }) => ({ error: occupant.ssnError }),
                    renderIf: ({ occupant, onReview }) => !!occupant.ssnError && !onReview,
                },
                {
                    component: WrappedInput,
                    name: 'HomePhone',
                    bindings: ({ language, occupant, occupants }) => ({ occupants, occupant, label: `${ language?.home_phone || 'Home Phone:'}`, value: occupant?.homePhone  || ''  })
                },
                {
                    component: WrappedInputError,
                    name: 'HomePhoneError',
                    bindings: ({ occupant }) => ({ error: occupant.homePhoneError || occupant.phoneError }),
                    renderIf: ({ occupant, onReview }) => (!!occupant.homePhoneError || !!occupant.phoneError) && !onReview,
                },
                {
                    component: WrappedInput,
                    name: 'WorkPhone',
                    bindings: ({ language, occupant, occupants }) => ({ occupants, occupant, label: `${ language?.work_phone || 'Work Phone'}:`, value: occupant?.workPhone  || '' })
                },
                {
                    component: WrappedInputError,
                    name: 'WorkPhoneError',
                    bindings: ({ occupant }) => ({ error: occupant.workPhoneError || occupant.phoneError }),
                    renderIf: ({ occupant, onReview }) => (!!occupant.workPhoneError || !!occupant.phoneError) && !onReview,
                },
                {
                    component: WrappedInput,
                    name: 'CellPhone',
                    bindings: ({ language, occupant, occupants }) => ({ occupants, occupant, label: `${ language?.cell_phone || 'Cell Phone'}:`, value: occupant?.cellPhone  || '' })
                },
                {
                    component: WrappedInputError,
                    name: 'CellPhoneError',
                    bindings: ({ occupant }) => ({ error: occupant.cellPhoneError || occupant.phoneError }),
                    renderIf: ({ occupant, onReview }) => (!!occupant.cellPhoneError || !!occupant.phoneError) && !onReview,
                },
            ]
        },
        {
            component: Seprator,
            name: 'Seprator',
            displayValue: () => '',
            renderIf: ({ occupant, occupants }) => isLastItem({ resource:occupant, resourceList:occupants })
        },
    ],
})

export default ContainerComponent(definition);
